import { render } from "./UIContainer.vue?vue&type=template&id=8463ebcc"
import script from "./UIContainer.vue?vue&type=script&lang=js"
export * from "./UIContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__